import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import cover from 'base/style_mixins/cover';

const styles = {
  root: {
    ...cover
  }
};

const Cover = ({ classes, children, dataTestId, ...props }) => {
  return (
    <Box classes={classes} data-testid={dataTestId} {...props}>
      {children}
    </Box>
  );
};

Cover.propTypes = {
  dataTestId: PropTypes.string,
  classes: PropTypes.shape({}).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default withStyles(styles)(Cover);
